export const v2TextMessageNotificationsText = "D34pd";
export const notifyBusinessText = "KRRcod";
export const sendCustomerInviteText = "Ufxpl";
export const enableTextNotifsText = "S_1add";
export const v2EmailReminderText = "HTR_qb";
export const v2DefautltReminderMessage = "ut8d0";
export const additionalInformationLabel = "fpvPrb";
export const v2AdditionalInformationPlaceholderText = "PvB7ue";
export const emailConfirmationText = "m7tti";
export const emailConfirmationDescription = "Pt3pee";
export const emailConfirmationSettingsText = "bqoU_c";
export const followUpEmailText = "$Culsc";
export const defaultFollowUpMessage = "OlrMG";
export const defaultFollowUpLinkText = "kVYhyd";
export const followUpEmailDescription = "wbP7fd";
export const bookingsEmailReminderDescription = "ALZeld";
export const teamsLicenseMessage = "spijyc";
export const learnMoreTeamsLink = "lIAq$b";
export default {v2TextMessageNotificationsText,notifyBusinessText,sendCustomerInviteText,enableTextNotifsText,v2EmailReminderText,v2DefautltReminderMessage,additionalInformationLabel,v2AdditionalInformationPlaceholderText,emailConfirmationText,emailConfirmationDescription,emailConfirmationSettingsText,followUpEmailText,defaultFollowUpMessage,defaultFollowUpLinkText,followUpEmailDescription,bookingsEmailReminderDescription,teamsLicenseMessage,learnMoreTeamsLink};